import { SOCIAL_LINKS } from "../../utils/routes";
import LinkWithSearchParams from "../UI/LinkWithSearchParams";
const LandingFooter = () => {
    return (
        <>
            <div className="flex flex-col lg:flex-row  w-full 2xl:px-64 xl:px-48 lg:px-32 px-6 lg:pt-20 lg:pb-12 pt-6 bg-[#212131]">
                <div className="flex flex-col grow pr-8 lg:w-[20vw]">
                    <div className="home-logo"></div>
                    <span className="size-base font-normal py-4">
                        Kadido is a autonomous launchpad built on the Kadena
                        blockchain
                    </span>
                </div>
                <div className="hidden lg:flex flex-col flex-initial w-48 2xl:w-64 mx-5">
                    <h5 className="mb-4 font-bold">Quick links</h5>
                    <div className="flex flex-col gap-2">
                        {navigate_links.map((item, i) => {
                            return (
                                <LinkWithSearchParams
                                    className="font-light"
                                    key={i}
                                    to={{ pathname: item.link }}
                                >
                                    {item.text}
                                </LinkWithSearchParams>
                            );
                        })}
                    </div>
                </div>
                <div className="hidden lg:flex flex-col flex-initial w-48 2xl:w-64 mx-5">
                    <h5 className="mb-4 font-bold">Doucments</h5>
                    <div className="flex flex-col gap-2">
                        {/* {privacy_links.map((item, i) => {
                            return (
                                <LinkWithSearchParams
                                    className="font-light"
                                    key={i}
                                    to={{ pathname: item.link }}
                                >
                                    {item.text}
                                </LinkWithSearchParams>
                            );
                        })} */}
                        {privacy_links_extern.map((item, i) => {
                            return (
                                <a
                                    href={item.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    key={i}
                                >
                                    {item.text}
                                </a>
                            );
                        })}
                    </div>
                </div>
                <div className="flex flex-col flex-initial w-full lg:w-80 lg:mx-5">
                    <h5 className="hidden lg:block mb-4 font-bold">
                        Join Newsletter
                    </h5>
                    <div className="relative">
                        <input
                            className="rounded-lg text-[14px] p-3 border-none bg-kadDarkBg w-full"
                            placeholder="Your Email"
                        />
                        <button className="blueGradient-button text-[14px] absolute top-0 right-0 p-2 rounded-lg border-[3px] border-kadDarkBg size-base font-semibold">
                            Subscribe
                        </button>
                    </div>
                    <div className="flex gap-2 my-4">
                        {SOCIAL_LINKS("w-6 h-6 fill-white").map((item, i) => (
                            <a
                                className="hover-gradient-button p-2"
                                href={item.link}
                                target="_blank"
                                rel="noreferrer"
                                key={i}
                            >
                                {item.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            <div className="w-full flex 2xl:px-64 xl:px-48 lg:px-32 px-6 bg-[#212131]">
                <div className="flex justify-center w-full py-4 border-t border-white/70">
                    <span>Copyright©2022.</span>
                    <span className="ml-1 text-kad-gradient">Kadido</span>
                </div>
            </div>
        </>
    );
};

export default LandingFooter;

const navigate_links = [
    {
        text: "Launchpad Dashboard",
        link: "/launchpad",
    },
    // {
    //     text: "DeFi Exchange",
    //     link: "/deFi-exchange",
    // },
    {
        text: "Lockers",
        link: "/lock-token",
    },
    {
        text: "Stake",
        link: "/stake",
    },
];

// const privacy_links = [
//     {
//         text: "Privacy and Policy",
//         link: "/privacy-policy",
//     },
//     {
//         text: "Terms and Conditions",
//         link: "/terms-conditions",
//     },
// ];

const privacy_links_extern = [
    {
        text: "Whitepaper",
        link: "Kadido.com",
        external: true,
    },
    {
        text: "KYC",
        link: "https://Kadido.com",
        nested: true,
        external: true,
    },
    {
        text: "Audit",
        link: "https://Kadido.com",
        external: true,
    },
];
